import type { PlanPeriod } from 'components';
import { JSX } from 'react';

import { Text } from '@videoblocks/design-system';

type UpgradeCreditPlanCardHeaderProps = {
    planName: string;
    price: number;
    selectedPeriod: PlanPeriod;
    currencySymbol: string;
};

export default function UpgradeCreditPlanCardHeader({
    planName,
    price,
    selectedPeriod,
    currencySymbol,
}: UpgradeCreditPlanCardHeaderProps): JSX.Element {
    return (
        <>
            <div className="mb-2">
                <Text fontSize="2xl" fontWeight="semibold" className="text-gray-900 font-polysans text-xl sm:text-2xl">
                    {planName}
                </Text>
            </div>

            <div className="mb-4">
                <div className="flex items-center justify-start gap-2">
                    <div className="flex items-baseline gap-1">
                        <Text fontSize="xl" fontWeight="semibold" className="text-gray-900">
                            {currencySymbol}
                        </Text>
                        <span className="text-4xl sm:text-5xl font-polysans font-semibold leading-tight sm:leading-[52px] tracking-tighter text-gray-900">
                            {price}
                        </span>
                    </div>
                    <Text fontSize="sm" fontWeight="regular" className="text-sm text-gray-600">
                        per{' '}
                        {selectedPeriod === 'monthly' ? (
                            'month'
                        ) : (
                            <>
                                month
                                <br />
                                billed annually
                            </>
                        )}
                    </Text>
                </div>
            </div>
        </>
    );
}
